import React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
const ContentView = (props) => {
    return (React.createElement(ContentViewStyled, { withSubMenu: props.withSubMenu }, props.children));
};
export default ContentView;
const ContentViewStyled = styled.div `
  margin-top: -${THEME.GRID_SPACING}px;
  width: 50%;
  position: absolute;
  left: 25%;
  height: ${(props) => `calc(100vh - ${props.withSubMenu
    ? THEME.NAV_TOP_HEIGHT + THEME.SUB_MENU_HEIGHT
    : THEME.NAV_TOP_HEIGHT}px);`}
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding: 1em;
`;
//# sourceMappingURL=ContentView.js.map